export default __webpack_public_path__ + "static/logo-30f7b59aeeedaee76265f895a9ae7be0.png";